import { Box, Stack, Typography } from '@mui/material'
import { IssueType } from '@planning/app/api'
import { ContainerVisitStatusChip } from '@planning/components/ContainerVisitStatusChip'
import { ContainerVisitsCardBody } from '@planning/pages/Order/components/ContainerVisitsCard/ContainerVisitsCardBody'
import { ContainerVisitsCardHeader } from '@planning/pages/Order/components/ContainerVisitsCard/ContainerVisitsCardHeader'
import { ContainerJourney } from '@planning/pages/ServiceOrders/Stores/ContainerJourney'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import _ from 'lodash'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { IIssueItem } from '../../Stores/IssueItem'

type Props = {
  issue?: IIssueItem
}

export const ResolveIssueCard: FC<Props> = observer(({ issue }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  if (!issue?.containerJourney) return <></>

  const containerVisit = ContainerJourney.create(issue.containerJourney)

  if (!containerVisit) return <></>

  return (
    <Box>
      <Typography variant='subtitle1'>
        {t(issue.issueTitle)}
        {issue.data.issueType === IssueType.UnknownCompany && `: ${issue.data.companyName}`}
      </Typography>

      <Box
        sx={{
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: theme.customRadius.medium,
          mt: '1rem',
        }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          sx={{ paddingRight: '1rem' }}
        >
          <ContainerVisitsCardHeader
            container={containerVisit.container}
            isDamaged={containerVisit.isDamagedContainer}
          />
          <ContainerVisitStatusChip
            label={t(_(containerVisit.status).lowerFirst())}
            status={containerVisit.status}
          />
        </Stack>

        <Box
          sx={{
            bgcolor: theme.palette.grey[100],
            borderTop: `1px solid ${theme.palette.grey[300]}`,
          }}
        >
          <ContainerVisitsCardBody containerVisit={containerVisit} isInsideIssueCard />
        </Box>
      </Box>
    </Box>
  )
})
